//helpers
export const urlParams = new URLSearchParams(window.location.search);
export const actuallyURL = new URL(window.location.href);

export function keyExistOnParams(key: string): boolean {
  return urlParams.has(key);
}
